import * as React from 'react'
import Svg, {Path, type SvgProps} from 'react-native-svg'

export function VideoCamera_Stroke2_Corner0_Rounded(props: SvgProps) {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M2 9.5C2 7.01472 4.01472 5 6.5 5H12.5C14.9853 5 17 7.01472 17 9.5V14.5C17 16.9853 14.9853 19 12.5 19H6.5C4.01472 19 2 16.9853 2 14.5V9.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17 12L22 8V16L17 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export function VideoCamera_Filled_Corner0_Rounded(props: SvgProps) {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M2 9.5C2 7.01472 4.01472 5 6.5 5H12.5C14.9853 5 17 7.01472 17 9.5V14.5C17 16.9853 14.9853 19 12.5 19H6.5C4.01472 19 2 16.9853 2 14.5V9.5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17 12L22 8V16L17 12Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
